import api from './api';

const BASE = '/api/land-values';

export const getLandValues     = (tenantId, params)  => api.get(`${BASE}/${tenantId}`, { params });
export const getLandValue      = (tenantId, id)       => api.get(`${BASE}/${tenantId}/${id}`);
export const submitLandValue   = (tenantId, data)     => api.post(`${BASE}/${tenantId}`, data);
export const updateLandValue   = (tenantId, id, data) => api.put(`${BASE}/${tenantId}/${id}`, data);
export const deleteLandValue   = (tenantId, id)       => api.delete(`${BASE}/${tenantId}/${id}`);
export const verifyLandValue   = (tenantId, id, data) => api.post(`${BASE}/${tenantId}/${id}/verify`, data);
export const getStats          = (tenantId)           => api.get(`${BASE}/${tenantId}/stats`);
export const getLandIntelligence = (params)           => api.get(`${BASE}/intelligence`, { params });
